import { render, staticRenderFns } from "./editPromotionTask.vue?vue&type=template&id=64754c1a&scoped=true&"
import script from "./editPromotionTask.vue?vue&type=script&lang=js&"
export * from "./editPromotionTask.vue?vue&type=script&lang=js&"
import style0 from "./editPromotionTask.vue?vue&type=style&index=0&id=64754c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64754c1a",
  null
  
)

export default component.exports